
// Services
import { type BlocTexteMediaType } from '@/services/blocksSchema';

// Components
import Heading from '@/components/atoms/Heading/Heading';
import Markdown from '@/components/atoms/Markdown/Markdown';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Utils
import cn from '@/utils/cn';

// Style
import styles from './BlocTexteMedia.module.css';

interface BlocTexteMediaProps {
  title?: BlocTexteMediaType['title'];
  description?: BlocTexteMediaType['description'];
  image: BlocTexteMediaType['image'];
  imagePosition: BlocTexteMediaType['imagePosition'];
}

function BlocTexteMedia({
  title = null,
  description = null,
  image,
  imagePosition,
}: BlocTexteMediaProps) {
  
  return (
    <div className={styles.container}>
      <div className={cn([
        styles.card,
        imagePosition === 'Gauche' ? styles['image-left'] : styles['image-right']
      ])}>
        <div className={styles.content}>
          {
            title ? (
              <div className={styles.heading}>
                <Heading
                  title={title}
                  size='h2'
                  Tag='h2'
                  color='dark'
                />
              </div>
            ) : null
          }
          {
            description ? (
              <Markdown
                text={description}
                className={styles.description}
              />
            ) : null
          }
        </div>
        <div className={styles.image}>
          <CmsImage media={image} sizes="(max-width: 1024px) 100vw, 50vw" />
        </div>
      </div>
    </div>
  );
}

export default BlocTexteMedia;
